import type { BeforeMountDefinition, MountedDefinition } from "./DirectiveDefinition";
import * as ga from "../../../utility/analytics/GoogleAnalytics/googleAnalyticsEvents";
import type { IPushEcommEvent } from "../../../utility/analytics/GoogleAnalytics/interfaces/IPushEvent";
import { findElement, inputElementTypes } from "./directiveHelpers";

const pushImpression = (binding: any) => {
  const impressionEvent = binding?.value();
  if (!impressionEvent) {
    return;
  }

  if (Array.isArray(impressionEvent)) {
    for (const event of impressionEvent) {
      if (!event.Products || event.Products.length === 0) {
        continue;
      }
      ga.ProductImpressions(event.Products);
    }
  } else if (impressionEvent.Products && impressionEvent.Products.length > 0) {
    ga.ProductImpressions(impressionEvent.Products);
  }
};

const pushEcomm = (binding: any) => {
  var eventBindings = binding?.value();
  if (!eventBindings) {
    return;
  }

  if (Array.isArray(eventBindings)) {
    for (const event of eventBindings) {
      ga.PushEcommEvent(event as IPushEcommEvent);
    }
  } else {
    ga.PushEcommEvent(eventBindings);
  }
};

/**
 * Definition for the analyticEcommDirective.
 */
const analyticEcommDefinition: BeforeMountDefinition = {
  beforeMount(el, binding, vnode, prevVnode) {
    findElement(el).addEventListener(binding.arg, () => pushEcomm(binding));
  },
};

/**
 * Definition for the analyticShowImpressionDirective.
 */
const analyticShowImpression: MountedDefinition = {
  mounted(el, binding, vNode, prevVnode) {
    pushImpression(binding);
  },
};

const analyticShowImpressionChange: BeforeMountDefinition = {
  beforeMount(el, binding, vnode, prevVnode) {
    findElement(el).addEventListener(binding.arg, () => pushImpression(binding));
  },
};

/**
 * Definition for the analyticAddZipDirective.
 */
const analyticAddZipDefinition: BeforeMountDefinition = {
  beforeMount(el, binding, vnode, prevVnode) {
    findElement(el).addEventListener(binding.arg, () => {
      var zipDefinition = binding?.value();
      if (!zipDefinition || !zipDefinition.ZipCode) {
        return;
      }

      ga.AddZipCode(zipDefinition.ZipCode, zipDefinition.List);
    });
  },
};

/**
 * Definition for the analyticOnMountedDirective.
 */
const analyticOnMountedDefinition: MountedDefinition = {
  mounted(el, binding, vNode, prevVnode) {
    if (typeof binding.value === "function") {
      binding?.value();
      return;
    }
    pushEcomm(binding);
  },
};

export {
  analyticEcommDefinition,
  analyticAddZipDefinition,
  analyticOnMountedDefinition,
  analyticShowImpression,
  analyticShowImpressionChange,
  pushImpression,
  pushEcomm,
};
